
import React, { Component } from "react";
import Table from "../../components/table/Table";
import moment from "moment";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../utils/Messages";
import ValidationText from "../../utils/validation/ValidationText";
import PageLoader from "../../components/common/pageLoader/PageLoader";
import { saveAs } from "file-saver";
import SlotMemberService from "../../services/axiosServices/apiServices/SlotMemberService";
import CPASMemberServices from "../../services/axiosServices/apiServices/CPASMemberServices";


export default class CPASRegistryListReport extends Component {
    constructor(props) {
        super(props);
        this.CPASMemberServices = new CPASMemberServices();

        this.state = {
            ACPCPASRegistryList:[],
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "CreatedAt",
                orderFlag: 0,
                searchText: "",
                startDate: "",
                endDate: "",

            },
            totalCount: 0,
            totalResultes: 0,
            previousReportFor: "",
            previousReportStartDate: "",
            previousReportEndDate: "",
            isLoading: false,
            outstandingInvoicesList: [],

            validState: {
                isValid: true,
                error: {},
            },
        };
    }



    setPagination = (newPagination) => {
        this.setState({ pagination: newPagination });
        this.getACPCPASRegistryList();
    };




    handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === 'startDate') {
            let date = this.state.pagination
            date.startDate = value
            this.setState({ startDate: date })
        }
        if (name === 'endDate') {
            let date = this.state.pagination
            date.endDate = value
            this.setState({ endDate: date })
        }
    }


    validateField = (key) => {
        const newValidState = validate(
            key,
            this.state.pagination,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
    };

    isValidateAllFields = () => {
        const newValidState = isValidForm(
            this.state.pagination,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };


    getACPCPASRegistryList = () => {


        this.setState({ isLoading: true });
        let request = { ...this.state.pagination };

        this.CPASMemberServices.getACPCPASRegistryList(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                if (response.responseItem.responseContent !== null) {
                    let details = response.responseItem.responseContent.itemList;

                    this.setState({
                        ACPCPASRegistryList: details,
                        totalCount: response.responseItem.responseContent.totalCount,
                        totalResultes: response.responseItem.responseContent.totalCount,
                    })
                }
            }
            else if (response.statusCode === 409) {
                this.swalServices.Error(response.message);
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });


    }

    downloadSheetForCPASRegistryListReport = () => {


        let request = { ...this.state.pagination };
        this.CPASMemberServices.downloadSheetForCPASRegistryListReport(request).then((response) => {
            if (response.status === 200 && response.data != null) {

                var blob = new Blob([response.data])
                // saveAs(blob, 'Slot Newly submitted Report' + ".xlsx");
                saveAs(blob, 'CPAS Registry List Report.xlsx');

            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });


    }

    render() {
        return (
            <div className="main-body-section finance-body-sec">
                <div className="bg-white px-8 py-10">
                    {/* Header Section from Image */}
                    <h1 className="text-3xl font-normal text-[#4A708B] mb-6">
                        ACP CPAS Registry List Report
                    </h1>


                    {/* Action Section */}
                    <div className="grid grid-cols-12 gap-6 w-full items-center mb-10">
                        <div className="col-span-4">
                            <button
                                className="btn btn-blue text-xl border text-white py-2 px-6"
                                onClick={() => this.getACPCPASRegistryList()}
                            >
                                Generate Registry List
                            </button>
                        </div>

                        {this.state.ACPCPASRegistryList &&
                            this.state.ACPCPASRegistryList.length > 0 && (
                                <div className="col-span-4">
                                    <button
                                        className="btn bg-green-600 text-xl border text-white py-2 px-6"
                                        onClick={() => this.downloadSheetForCPASRegistryListReport()}
                                    >
                                        Download Excel
                                    </button>
                                </div>
                            )}
                    </div>

                    {/* Table Section */}
                    <div className="grid grid-cols-12 gap-6 w-full">
                        <div className="col-span-12 w-full">
                            {this.state.isLoading ? (
                                <PageLoader />
                            ) : (
                                <Table

                                    columns={[
                                        { name: "ApplicationTierId", title: "Accreditation Tier", },
                                        { name: "Name", title: "Name" },
                                        { name: "CertificateMembershipNo", title: "Registration Number" },


                                    ]}
                                    pagination={this.state.pagination}
                                    rows={this.state.ACPCPASRegistryList}
                                    sortingColumns={["AccreditationTier", "Name"]}
                                    isLoading={this.state.isLoading}
                                    totalResultes={this.state.totalResultes}
                                    totalCount={this.state.totalCount}
                                    setPagination={this.setPagination.bind(this)}



                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}